<app-smart-input-entity
  fieldLabel="name"
  [control]="control()"
  [handler]="workPackagePickerHandler()"
  [placeholder]="placeholder()"
  [resetValue]="resetValue()">
  <ng-template
    let-item="item"
    appTemplate="filter">
    @if (cast(item); as type) {
      <app-wp-type-badge
        [wpType]="{
          name: type.name,
          color: type.color.text,
          icon: type.icon ?? undefined
        }" />
    }
  </ng-template>
</app-smart-input-entity>
